export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-zinc-900 mt-16"
    >
      <div className="px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-extrabold text-3xl tracking-tight text-white">
            ZEBRA<span className="text-[#FF5612]">LEARN</span>
          </div>
          <p className="text-sm text-zinc-400 mt-3 max-w-md leading-relaxed">
            Smarter learning starts with the right plan. Find a Zebralearn store near you and
            join our growing community of curious readers.
          </p>
        </div>
        <div>
          <div className="text-xs font-semibold tracking-[0.18em] uppercase mb-4 text-[#FF5612]">Locator</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="text-zinc-300 hover:text-[#FF5612] transition-colors">All Stores</a></li>
            <li><a href="/?tab=events" className="text-zinc-300 hover:text-[#FF5612] transition-colors">Events</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold tracking-[0.18em] uppercase mb-4 text-[#FF5612]">Visit</div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://zebralearn.com" target="_blank" rel="noreferrer" className="text-zinc-300 hover:text-[#FF5612] transition-colors">Main Site →</a></li>
            <li><a href="https://zebralearn.com" target="_blank" rel="noreferrer" className="text-zinc-300 hover:text-[#FF5612] transition-colors">ZebraLearn Prime</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 px-6 md:px-12 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} ZebraLearn. All rights reserved.</span>
        <span className="uppercase tracking-[0.18em]">Built for readers, by learners.</span>
      </div>
    </footer>
  );
};

export default Footer;
